var map = {
	"./behance.svg": 5805,
	"./bluesky.svg": 438,
	"./close.svg": 5837,
	"./dribbble.svg": 5957,
	"./grid.svg": 3591,
	"./instagram.svg": 5373,
	"./left-arrow.svg": 2104,
	"./list.svg": 71,
	"./menu_hamburger.svg": 2982,
	"./menu_x.svg": 5043,
	"./twitch.svg": 7434,
	"./x.svg": 9897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;